import { GetterTree } from 'vuex';
import RootState from '@/store/RootState';
import { FiltersState } from './typings';
import { Filter } from '@/services/filters';

const getters: GetterTree<FiltersState, RootState> = {
  all(state): Record<string, Filter> {
    return state.byId;
  },
  byId: (state) => (id: any) => state.byId[id],
};


export default getters;
